export default "__VITE_ASSET__VJJ42gfC__"